<template>
    <div>
        <div class="box view-nav-bar">
            <div class="d-flex align-items-center w-100">
                <div class="flex-grow-1">
                    <router-link :to="'/history/' + movixId + '/month'" class="mr-3">
                        <icon name="chevron-left"/> Per Month
                    </router-link>
                    <strong>{{ movieTitle }}</strong>
                    <span class="text-muted ml-2">— {{ month }} — {{ modeLabel }}</span>
                </div>
                <div>
                    <router-link :to="'/history/' + movixId + '/month/' + month + '/day'"
                                 class="btn btn-sm mr-2"
                                 :class="mode === 'day' ? 'btn-primary' : 'btn-outline-secondary'">
                        Per Day
                    </router-link>
                    <router-link :to="'/history/' + movixId + '/month/' + month + '/site'"
                                 class="btn btn-sm"
                                 :class="mode === 'site' ? 'btn-primary' : 'btn-outline-secondary'">
                        Per Cinema
                    </router-link>
                </div>
            </div>
        </div>

        <div v-if="loading" class="box">
            <div class="box-content text-center text-muted py-4">Loading…</div>
        </div>

        <div v-else-if="!rows.length" class="box">
            <div class="box-content text-center text-muted py-4">No admissions data found.</div>
        </div>

        <div v-else class="box">
            <div class="box-content">
                <table class="shx-table w-100 mt-2">
                    <thead>
                        <tr>
                            <th class="shx-th-150">{{ columnLabel }}</th>
                            <th class="shx-th-120 text-right">Admissions</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="rowKey(row)">
                            <td>{{ rowLabel(row) }}</td>
                            <td class="text-right">{{ formatInt(row.admissions) }}</td>
                            <td>
                                <div class="bg-secondary"
                                     :style="{width: barWidth(row.admissions), height: '8px'}"></div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><strong>Total</strong></td>
                            <td class="text-right"><strong>{{ formatInt(totalAdmissions) }}</strong></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['movixId', 'month', 'mode'],
    data() {
        return {
            loading: true,
            rows: [],
        };
    },
    computed: {
        movieTitle() {
            const current = this.$store.getters.historyCurrent;
            return (current && current.movix_title) ? current.movix_title : `Movix #${this.movixId}`;
        },
        modeLabel() {
            return this.mode === 'day' ? 'per day' : 'per cinema';
        },
        columnLabel() {
            return this.mode === 'day' ? 'Day' : 'Cinema';
        },
        totalAdmissions() {
            return this.rows.reduce((sum, r) => sum + (r.admissions || 0), 0);
        },
        maxAdmissions() {
            return Math.max(...this.rows.map(r => r.admissions || 0), 1);
        },
    },
    watch: {
        mode() {
            this.loadData();
        },
    },
    created() {
        this.ensureMovieLoaded();
        this.loadData();
    },
    methods: {
        ensureMovieLoaded() {
            const current = this.$store.getters.historyCurrent;
            if (!current || String(current.movix_id) !== String(this.movixId)) {
                this.$store.dispatch('fetchHistory', this.movixId).catch(() => {});
            }
        },
        loadData() {
            this.loading = true;
            this.rows = [];
            const url = `/history/${this.movixId}/month/${this.month}/${this.mode}`;
            axios
                .get(url)
                .then(response => {
                    this.rows = response.data.data.rows || [];
                })
                .catch(error => {
                    this.$toast.error(error.response?.data?.error?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        rowKey(row) {
            return this.mode === 'day' ? row.day : row.theatre_code;
        },
        rowLabel(row) {
            return this.mode === 'day' ? row.day : row.theatre_code;
        },
        barWidth(admissions) {
            const pct = Math.round((admissions || 0) / this.maxAdmissions * 100);
            return pct + '%';
        },
        formatInt(v) {
            return Math.round(v || 0).toLocaleString();
        },
    },
};
</script>
